import{useSelector as r}from"react-redux";const e=()=>r((r=>r.queryBuilderCache));export{e as useQueryBuilderCacheSelector};
